// import Spinner from 'react-bootstrap/Spinner';

// function BtnSpinner() {
//   return (
//     <>
//       <Spinner animation="border" variant="primary" />
//       <Spinner animation="border" variant="secondary" />
//       <Spinner animation="border" variant="success" />
//       <Spinner animation="border" variant="dark" />
//       <Spinner animation="border" variant="warning" />
//       <Spinner animation="border" variant="info" />
//       <Spinner animation="border" variant="light" />
//       <Spinner animation="border" variant="dark" />
//       <Spinner animation="grow" variant="primary" />
//       <Spinner animation="grow" variant="secondary" />
//       <Spinner animation="grow" variant="success" />
//       <Spinner animation="grow" variant="danger" />
//       <Spinner animation="grow" variant="warning" />
//       <Spinner animation="grow" variant="info" />
//       <Spinner animation="grow" variant="light" />
//       <Spinner animation="grow" variant="dark" />
//     </>
//   );
// }

// export default BtnSpinner;

import * as React from 'react';
// import Stack from '@mui/material/Stack';
// import CircularProgress from '@mui/material/CircularProgress';

export default function CircularColor() {
  return (
    <div></div>
    // <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row">
    //   <CircularProgress color="inherit" />
    // </Stack>
  );
}